import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import FileUpload from '../../../FileUpload/FileUpload';
import FieldWrap from '../FieldWrap/FieldWrap';

var UploadFileComponent = /*#__PURE__*/function (_Component) {
  _inherits(UploadFileComponent, _Component);

  function UploadFileComponent() {
    _classCallCheck(this, UploadFileComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(UploadFileComponent).apply(this, arguments));
  }

  _createClass(UploadFileComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          files = _this$props.files,
          input = _this$props.input,
          uploadingFiles = _this$props.uploadingFiles,
          handleChange = _this$props.handleChange,
          label = _this$props.label,
          displayNotes = _this$props.displayNotes,
          meta = _this$props.meta;
      var file = files && files[input.name];
      var hasError = meta.touched && meta.error; // disable if any file upload is in progress

      var isDisabled = !!(uploadingFiles && uploadingFiles.length);
      return React.createElement('div', {
        className: "file-upload-bir ".concat(hasError ? 'error' : '')
      }, React.createElement('label', null, label), React.createElement(FieldWrap, {
        meta: meta,
        displayNotes: displayNotes
      }, React.createElement(FileUpload, {
        file: file,
        fieldName: input.name,
        isUploading: includes(uploadingFiles, input.name),
        onDelete: function onDelete() {
          input.onChange(null);
          handleChange(input.name);
        },
        input: input,
        disabled: isDisabled
      })));
    }
  }]);

  return UploadFileComponent;
}(Component);

UploadFileComponent.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.element.isRequired,
  displayNotes: PropTypes.string
};
export default UploadFileComponent;